"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAllowedRestriction = exports.getChildrenAndInfantsHouseRules = void 0;
const getChildrenAndInfantsHouseRules = (children, infants) => {
    if (children && infants) {
        return 'Children and infants are allowed.';
    }
    else if (children && !infants) {
        return 'Children are allowed.';
    }
    else if (!children && infants) {
        return 'Infants are allowed.';
    }
    else
        return 'Children and infants are not allowed.';
};
exports.getChildrenAndInfantsHouseRules = getChildrenAndInfantsHouseRules;
const hasAllowedRestriction = (name, restrictions) => {
    const found = restrictions.find((r) => r.restriction_type === name);
    return !!found && found.allowed;
};
exports.hasAllowedRestriction = hasAllowedRestriction;
//# sourceMappingURL=helpers.js.map